import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSliderModule } from '@angular/material/slider';
import { RouterModule } from '@angular/router';
import { NgxSliderModule } from '@ascenda/ngx-slider';
import { TranslateModule } from '@ngx-translate/core';
import { ErrorMessageHelper } from '@rd/helpers/error-message.helper';
import { RdAlertModule } from './components/alert/alert.module';
import { BottomBarComponent } from './components/bottom-bar/bottom-bar.component';
import { BreadcrumbModule } from './components/breadcrumb/breadcrumb.module';
import { ButtonModule } from './components/button/button.module';
import { CarouselInnerItemContainerDirective } from './components/carousel/carousel-inner-item-container.directive';
import { CarouselItemDirective } from './components/carousel/carousel-item.directive';
import { CarouselComponent } from './components/carousel/carousel.component';
import { CashPointsSliderComponent } from './components/cash-points-slider/cash-points-slider.component';
import { CheckoutErrorDialogComponent } from './components/checkout-error-dialog/checkout-error-dialog.component';
import { CounterComponent } from './components/counter/counter.component';
import { DynamicListComponent } from './components/dynamic-list/dynamic-list.component';
import { ErrorSignComponent } from './components/error-sign/error-sign.component';
import { FulfillmentProcessingLoaderComponent } from './components/fulfillment-processing-loader/fulfillment-processing-loader.component';
import { IconModule } from './components/icon/icon.module';
import { LinkModule } from './components/link/link.module';
import { NavPillsItemDirective } from './components/nav-pills/nav-item.directive';
import { NavPillsInnerItemContainerDirective } from './components/nav-pills/nav-pills-inner-item.directive';
import { NavPillsComponent } from './components/nav-pills/nav-pills.component';
import { PaginationComponent } from './components/pagination/pagination.component';
import { PanelAccordionComponent } from './components/panel-accordion/panel-accordion.component';
import { SectionTitleComponent } from './components/section-title/section-title.component';
import { RdSpinnerComponent } from './components/spinner/spinner.component';
import { ClickOutsideModule } from './directives/click-outside/click-outside.module';
import { DynamicComponentDirective } from './directives/dynamic-component/dynamic-component.directive';
import { ImageFallbackDirective } from './directives/image-fallback/image-fallback.directive';
import { OpenInNewTabModule } from './directives/open-in-new-tab/open-in-new-tab.module';
import { ScrollDetectDirectiveModule } from './directives/scroll-detect/scroll-detect.directive.module';
import { LocalizeCurrencyPipe } from './pipes/custom-currency/localize-currency.pipe';
import { DisplayPositiveNumbersPipe } from './pipes/display-positive-numbers/display-positive-numbers.pipe';
import { LocalizeDateModule } from './pipes/localize-date/localize-date.module';
import { LocalizeNumberPipeModule } from './pipes/localize-number/localize-number.pipe';
import { LocalizePercentPipe } from './pipes/localize-percent/localize-percent.pipe';
import { LocalizePointsNumberPipeModule } from './pipes/localize-points-number/localize-points-number.pipe';
import { LocalizePointsStatementPipe } from './pipes/localize-points-statement/localize-points-statement.pipe';
import { LocalizePointsTransactionPipeModule } from './pipes/localize-points-transaction/localize-points-transaction.module';
import { AriaPhoneNumberModule } from './widgets/aria-phone-number/';

const declaredComponents: any[] = [
  BottomBarComponent,
  CarouselComponent,
  CarouselInnerItemContainerDirective,
  CarouselItemDirective,
  CashPointsSliderComponent,
  DynamicListComponent,
  ErrorSignComponent,
  CheckoutErrorDialogComponent,
  FulfillmentProcessingLoaderComponent,
  PanelAccordionComponent,
  PaginationComponent,
  SectionTitleComponent,
  NavPillsInnerItemContainerDirective,
  NavPillsItemDirective,
  NavPillsComponent,
];

const declaredDirectives = [DynamicComponentDirective, ImageFallbackDirective];

const declaredPipes = [
  DisplayPositiveNumbersPipe,
  LocalizePercentPipe,
  LocalizeCurrencyPipe,
  LocalizePointsStatementPipe,
];

const independentModules = [
  BreadcrumbModule,
  ButtonModule,
  ClickOutsideModule,
  IconModule,
  LinkModule,
  LocalizeDateModule,
  LocalizeNumberPipeModule,
  LocalizePointsNumberPipeModule,
  LocalizePointsTransactionPipeModule,
  OpenInNewTabModule,
  RdAlertModule,
  RdSpinnerComponent,
  ScrollDetectDirectiveModule,
];

@NgModule({
  declarations: [
    ...declaredComponents,
    ...declaredDirectives,
    ...declaredPipes,
  ],
  imports: [
    ...independentModules,
    AriaPhoneNumberModule,
    CommonModule,
    FormsModule,
    MatSliderModule,
    MatIconModule,
    MatInputModule,
    MatExpansionModule,
    NgxSliderModule,
    ReactiveFormsModule,
    RouterModule,
    TranslateModule,
    MatFormFieldModule,
    CounterComponent,
  ],
  exports: [
    ...declaredComponents,
    ...declaredDirectives,
    ...declaredPipes,
    ...independentModules,
    MatIconModule,
    ReactiveFormsModule,
    FormsModule,
    TranslateModule,
    CounterComponent,
  ],
  providers: [...declaredPipes, ErrorMessageHelper],
})
export class SharedModule {}
